import * as actionTypes from './actionTypes';

const _LIMIT_ = 1000;

export const searchTags = (search, options = {}) => {
    return (dispatch) => {
        const op = { ...options, limit: _LIMIT_ };
        dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_START });
        window.flow.searchTags(search, op/*options*/).then((res) => {
            //console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_SUCCESS, tags: res });
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_FAIL });
        });
    };
};

export const searchAllTags = (search, options = {}, tags = {}) => {
    return (dispatch) => {
        const offset = options.offset || 0;
        const op = { ...options, op: 'listall', showpic: false, limit: _LIMIT_ , offset: offset};
        dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_START });
        window.flow.searchTags(search, op).then((res) => {
            const vals = Object.values(res);
            if(vals.length < _LIMIT_) {
                vals.forEach(val => {
                    tags[val.id] = val;
                });
                dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_SUCCESS, tags: tags });
            } else {
                vals.forEach(val => {
                    tags[val.id] = val;
                });
                dispatch(searchAllTags("", { offset: offset + _LIMIT_ }, tags));
            }
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_FAIL });
        });
    };
};

export const newTag = (tag) => {
    return (dispatch) => {
        console.log(tag);
        dispatch({ type: actionTypes.TAG_CATALOG_NEW_START });
        window.flow.newTag(tag).then((res) => {
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_SUCCESS, id : res[0], tag: tag });
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_FAIL });
        });
    };
};

export const editTag = (id, tag) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_EDIT_START });
        window.flow.editTag(id, tag).then((res) => {
            dispatch({ type: actionTypes.TAG_CATALOG_EDIT_SUCCESS, id: id, tag: tag });
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_EDIT_FAIL });
        });
    };
};

export const deleteTag = (id) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_DELETE_START });
        window.flow.delTag(id).then((res) => {
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_SUCCESS, id: id });
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_FAIL });
        });
    };
};

export const newRelation = (rel, tagIdA, tagIdB) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_START });
        window.flow.newRelation(rel).then((res) => {
            //console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_SUCCESS });
            dispatch(relatedTags(tagIdA));
            dispatch(relatedTags(tagIdB));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_FAIL });
        });
    };
};

export const delRelation = (id, tagIdA, tagIdB) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_START });
        window.flow.delRelation(id).then((res) => {
            //console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_SUCCESS });
            dispatch(relatedTags(tagIdA));
            dispatch(relatedTags(tagIdB));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_FAIL });
        });
    };
};

export const relatedTags = (id, rel = {}) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_START });
        window.flow.relatedTags(id, rel).then((res) => {
            //console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_SUCCESS, id: id, rels: res });
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_FAIL });
        });
    };
};

export const searchAllTree = (search, options = {}, tags = {}) => {
    return (dispatch) => {
        const offset = options.offset || 0;
        const op = { ...options, op: 'listall', showpic: false, limit: _LIMIT_ , offset: offset, relation: 'parent' };
        dispatch({ type: actionTypes.TAG_TREE_SEARCH_START });
        window.flow.searchTags(search, op).then((res) => {
            
            const vals = Object.values(res);
            if(vals.length < _LIMIT_) {
                vals.forEach(val => {
                    //console.log(val.relids);
                    tags[val.id] = val;
                });
                dispatch({ type: actionTypes.TAG_TREE_SEARCH_SUCCESS, tags: tags });
            } else {
                vals.forEach(val => {
                    tags[val.id] = val;
                });
                dispatch(searchAllTree("", { offset: offset + _LIMIT_ }, tags));
            }
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_TREE_SEARCH_FAIL });
        });
    };
};

export const newTreeTag = (tag, type, id) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_TREE_NEW_START });
        window.flow.newTag(tag).then((res) => {
            dispatch({ type: actionTypes.TAG_TREE_NEW_SUCCESS});
            if(id) {
                const rel = {
                    taga_id: id,
                    tagb_id: res[0],
                    relation_ab: "parent",
                    relation_ba: "child"
                }
                window.flow.newRelation(rel).then((res) => {
                    dispatch(searchAllTree("", { type: type }));
                });
            } else {
                dispatch(searchAllTree("", { type: type }));
            }
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_TREE_NEW_FAIL });
        });
    };
};

export const editTreeTag = (id, tag, type) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_TREE_EDIT_START });
        window.flow.editTag(id, tag).then((res) => {
            dispatch({ type: actionTypes.TAG_TREE_EDIT_SUCCESS });
            dispatch(searchAllTree("", { type: type }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_TREE_EDIT_FAIL });
        });
    };
};

export const deleteTreeTag = (id, type) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_TREE_DELETE_START });
        window.flow.delTag(id).then((res) => {
            //console.log(res);
            dispatch({ type: actionTypes.TAG_TREE_DELETE_SUCCESS });
            dispatch(searchAllTree("", { type: type }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_TREE_DELETE_FAIL });
        });
    };
};

export const relatedTreeTags = (id, refId, type) => {
    return (dispatch) => {
        //dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_START });
        window.flow.relatedTags(id, {}).then((res) => {
            //console.log(res);
            // delete all child relations (should only be 1 relation)
            res.b.forEach(rel => {
                window.flow.delRelation(rel.relid).then((res) => {
                    //console.log(res);
                    if(refId === -1) {
                        dispatch(searchAllTree("", { type: type }));
                    }
                    //dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_SUCCESS });
                }).catch(res => {
                    //dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_FAIL });
                });
            });
            
            if(refId !== -1) {
                const rel = {
                    taga_id: refId,
                    tagb_id: id,
                    relation_ab: "parent",
                    relation_ba: "child"
                }
                
                window.flow.newRelation(rel).then((res) => {
                    //console.log(res);
                    //dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_SUCCESS });
                    dispatch(searchAllTree("", { type: type }));
                }).catch(res => {
                    //dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_FAIL });
                });
            }
    
            //dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_SUCCESS, id: id, rels: res });
        }).catch(res => {
            //dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_FAIL });
        });
    };
};
